(function () {
    'use strict';

    angular
        .module('app.service', [
            'ODataResources',
            'blocks.exception'
        ]);
})();
